let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fGahR")).then(() => parcelRequire('4Kf1A'));